// extracted by mini-css-extract-plugin
module.exports = {"text":"simpleText-module--text--14D-W","fontsLoading":"simpleText-module--fonts-loading--3w8gO"};